import { proxy } from "valtio";

export const contactInfoSalesContactState = proxy<{
  showContactInfoSalesContact: boolean;
}>({
  showContactInfoSalesContact: false,
});
